module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "exit-save"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-exit-save",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "centered": ""
    },
    on: {
      "hide": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.back
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.exit')) + "\n      ")]), _vm._v(" "), _c('button', {
          staticClass: "btn outline-secondary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel')) + "\n      ")])]
      },
      proxy: true
    }])
  }, [_c('svg', {
    attrs: {
      "width": "128px",
      "height": "128px",
      "viewBox": "0 0 128 128",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-248.000000, -117.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(48.000000, 117.000000)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(200.000000, 0.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M120,0 L24,0 C19.578,0 16,3.582 16,8 L16,30.234 C18.367,28.101 21.063,26.496 24,25.453 L24,8 L120,8 L120,120 L24,120 L24,102.547 C21.062,101.504 18.367,99.899 16,97.766 L16,120 C16,124.418 19.578,128 24,128 L120,128 C124.422,128 128,124.418 128,120 L128,8 C128,3.582 124.422,0 120,0 Z",
      "fill": "#B0BEC5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,40 C34.047,40 36.094,40.781 37.656,42.344 C40.781,45.469 40.781,50.532 37.656,53.657 L35.313,56 L64,56 C68.422,56 72,59.582 72,64 C72,68.418 68.422,72 64,72 L35.313,72 L37.657,74.344 C40.782,77.469 40.782,82.532 37.657,85.657 C36.094,87.219 34.047,88 32,88 C29.953,88 27.906,87.219 26.344,85.656 L10.344,69.656 C7.219,66.531 7.219,61.468 10.344,58.343 L26.344,42.343 C27.906,40.781 29.953,40 32,40 M32,32 C27.727,32 23.711,33.664 20.687,36.688 L4.687,52.688 C1.664,55.711 0,59.727 0,64 C0,68.273 1.664,72.289 4.688,75.313 L20.688,91.313 C23.711,94.336 27.727,96 32,96 C36.273,96 40.289,94.336 43.313,91.312 C46.43,88.195 47.993,84.097 47.993,79.999 L64,79.999 C72.82,79.999 80,72.823 80,63.999 C80,55.179 72.82,47.999 64,47.999 L47.992,47.999 C47.992,43.901 46.429,39.804 43.312,36.686 C40.289,33.664 36.273,32 32,32 L32,32 Z",
      "fill": "#F44336"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,24 L104,104 L96,104 L96,24 L104,24 M112,16 L88,16 L88,112 L112,112 L112,16 L112,16 Z",
      "fill": "#EF9A9A"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-2 title"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('exitSave.exitEditor')) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "my-2 subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('exitSave.exitPage')) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e291e408","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ExitSave.vue
// module id = 851
// module chunks = 1 3